import { ResponsiveType } from 'react-multi-carousel';

// desktop
const commonCarouselResponsiveProperties: ResponsiveType = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const carouselResponsivePropertiesCollection: ResponsiveType = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

// mobile
const commonCarouselResponsivePropertiesMobile: ResponsiveType = {
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 4,
  },
  extraTablet: {
    breakpoint: { max: 767, min: 501 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 500, min: 389 },
    items: 2.5,
  },
  extraMobile: {
    breakpoint: { max: 388, min: 341 },
    items: 2,
  },
  extraExtraMobile: {
    breakpoint: { max: 340, min: 0 },
    items: 1.5,
  },
};

const commonCarouselResponsiveSkusMobile: ResponsiveType = {
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 4,
  },
  extraTablet: {
    breakpoint: { max: 767, min: 678 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 677, min: 566 },
    items: 2.5,
  },
  extraMobile: {
    breakpoint: { max: 565, min: 478 },
    items: 2,
  },
  extraExtraMobile: {
    breakpoint: { max: 477, min: 0 },
    items: 1.2,
  },
};
const carouselResponsivePropertiesCollectionMobile: ResponsiveType = {
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 1.5,
  },
  extraTablet: {
    breakpoint: { max: 767, min: 501 },
    items: 1.5,
  },
  mobile: {
    breakpoint: { max: 500, min: 389 },
    items: 1.5,
  },
  extraMobile: {
    breakpoint: { max: 388, min: 341 },
    items: 1.5,
  },
  extraExtraMobile: {
    breakpoint: { max: 340, min: 0 },
    items: 1.5,
  },
};

const carouselResponsivePropertiesBrandsMobile: ResponsiveType = {
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 5,
  },
  extraTablet: {
    breakpoint: { max: 767, min: 576 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 576, min: 389 },
    items: 3.5,
  },
  extraMobile: {
    breakpoint: { max: 388, min: 341 },
    items: 3,
  },
  extraExtraMobile: {
    breakpoint: { max: 340, min: 0 },
    items: 2.5,
  },
};

const carouselResponsivePropertiesBlogMobile: ResponsiveType = {
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 4,
  },
  extraTablet: {
    breakpoint: { max: 767, min: 576 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 576, min: 389 },
    items: 2,
  },
  extraMobile: {
    breakpoint: { max: 388, min: 0 },
    items: 1.5,
  },
};

const carouselResponsivePropertiesLastActivitiesMobile: ResponsiveType = {
  mobile: {
    breakpoint: { max: 992, min: 0 },
    items: 1,
  },
};

export {
  commonCarouselResponsiveProperties,
  commonCarouselResponsivePropertiesMobile,
  carouselResponsivePropertiesCollection,
  carouselResponsivePropertiesCollectionMobile,
  carouselResponsivePropertiesBrandsMobile,
  carouselResponsivePropertiesBlogMobile,
  commonCarouselResponsiveSkusMobile,
  carouselResponsivePropertiesLastActivitiesMobile,
};
